import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Button, Dialog, TextField, Switch, Snackbar } from '@mui/material';

const AdminUserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingUser, setEditingUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('/api/admin/users');
        setUsers(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users:', error);
        setSnackbarMessage('Error fetching users');
        setSnackbarOpen(true);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const showEditModal = (user) => {
    setEditingUser(user);
    setFormValues(user);
    setIsModalVisible(true);
  };

  const handleUpdateUser = async () => {
    try {
      const response = await axios.put(`/api/admin/users/${editingUser._id}`, formValues);
      setUsers(users.map(user => (user._id === response.data._id ? response.data : user)));
      setSnackbarMessage('User updated successfully');
      setSnackbarOpen(true);
      setIsModalVisible(false);
    } catch (error) {
      console.error('Error updating user:', error);
      setSnackbarMessage('Error updating user');
      setSnackbarOpen(true);
    }
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const columns = [
    {
      title: 'Name',
      field: 'name',
    },
    {
      title: 'Email',
      field: 'email',
    },
    {
      title: 'Role',
      field: 'role',
    },
    {
      title: 'Verified',
      field: 'isVerified',
      render: (rowData) => (rowData.isVerified ? 'Yes' : 'No'),
    },
    {
      title: 'Active',
      field: 'isActive',
      render: (rowData) => (rowData.isActive ? 'Yes' : 'No'),
    },
    {
      title: 'Actions',
      render: (rowData) => (
        <span>
          <Button variant="outlined" onClick={() => showEditModal(rowData)}>Edit</Button>
          <Button variant="outlined" onClick={() => handleUpdateUser({ isActive: !rowData.isActive })}>
            {rowData.isActive ? 'Block' : 'Unblock'}
          </Button>
        </span>
      ),
    },
  ];

  return (
    <div>
      <h2>Manage Users</h2>
      <Table
        columns={columns}
        data={users}
        isLoading={loading}
        options={{
          search: true,
          paging: true,
          filtering: true,
          actionsColumnIndex: -1,
        }}
      />

      <Dialog
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        aria-labelledby="form-dialog-title"
      >
        <div style={{ padding: 20 }}>
          <h2 id="form-dialog-title">Edit User</h2>
          <TextField
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            name="name"
            value={formValues.name || ''}
            onChange={handleFormChange}
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            name="email"
            value={formValues.email || ''}
            onChange={handleFormChange}
          />
          <TextField
            margin="dense"
            label="Role"
            type="text"
            fullWidth
            name="role"
            value={formValues.role || ''}
            onChange={handleFormChange}
          />
          <div>
            <label>Verified</label>
            <Switch
              checked={formValues.isVerified || false}
              onChange={handleFormChange}
              name="isVerified"
            />
          </div>
          <div>
            <label>Active</label>
            <Switch
              checked={formValues.isActive || false}
              onChange={handleFormChange}
              name="isActive"
            />
          </div>
          <Button onClick={handleUpdateUser} color="primary">
            Update
          </Button>
        </div>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
    </div>
  );
};

export default AdminUserManagement;